import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import StaffTable from '../../../components/formule/StaffTable';


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      display: "flex",
      justifyContent: "space-between",
    }
  }));





  const Staff = () => {
    const classes = useStyles();
   return(
    <div>
  <div className="content-wrapper  " style={{marginTop:"0"}}>
     
    <div className="content-header ">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
              
            <h1 className="m-0">Personnls</h1>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item"><a href="#">Accueil</a></li>
              <li className="breadcrumb-item active">Personnls</li>
            </ol>
            
          </div>
        </div>
      </div>
    </div>
    <Grid container spacing={0} className={classes.root} >
    <Grid item xs={12} >
         <StaffTable></StaffTable>
       
        </Grid>
          
        
       
        
        </Grid>


   
  </div>
  </div>
  

    ); 
  
  }
  export default Staff